'use client';

import Link from 'next/link';
import { useEffect, useState } from 'react';
import { signIn } from 'next-auth/react';
import { SubmitHandler } from 'react-hook-form';
import { PiArrowRightBold } from 'react-icons/pi';
import { Checkbox, Password, Button, Input, Text } from 'rizzui';
import { Form } from '@core/ui/form';
import { routes } from '@/config/routes';
import { loginSchema, LoginSchema } from '@/validators/login.schema';
import { FetchClient } from '@/lib/FetchClient';
import { useRouter } from 'next/navigation';
import { usePresets } from '@/config/color-presets';
import { useColorPresets } from '@/layouts/settings/use-theme-color';
import { useCommon } from '../store/use-common';
const initialValues: LoginSchema = {
  id: '',
  password: '',
  rememberMe: true,
};

export default function SignInForm() {
  const COLOR_PRESETS = usePresets();
  const { setColorPresets } = useColorPresets();
  //TODO: why we need to reset it here
  const [reset, setReset] = useState({});
  const router = useRouter();
  const { setValue } = useCommon();

  const onSubmit: SubmitHandler<LoginSchema> = async (data) => {
    console.log(data);
    FetchClient('/auth/login', {
      method: 'POST',
      body: JSON.stringify({
        userId: data.id,
        password: data.password,
      }),
    })
      .then((res) => {
        if (res.status == 'success') {
          let mRole = res.mRole;
          let home = mRole == 0 ? '/store/list' : '/room/list';

          setValue('home', home);
          location.href = home;
        } else {
          alert(res.error);
          // setReset({ id: '', password: '' });
        }
      })
      .catch((e) => {
        console.error(e);
        alert(e);
        // setReset({ email: '', password: '' });
      });
  };

  useEffect(() => {
    setColorPresets(COLOR_PRESETS[0].colors);
  }, []);

  return (
    <>
      <Form<LoginSchema>
        validationSchema={loginSchema}
        resetValues={reset}
        onSubmit={onSubmit}
        useFormProps={{
          mode: 'onChange',
          defaultValues: initialValues,
        }}
      >
        {({ register, formState: { errors } }) => (
          <div className="space-y-5">
            <Input
              type="text"
              size="lg"
              label="이메일"
              placeholder="이메일주소를 입력해주세요"
              className="[&>label>span]:font-medium"
              inputClassName="text-sm"
              {...register('id')}
              error={errors.id?.message}
            />
            <Password
              label="비밀번호"
              placeholder="비밀번호를 입력해주세요"
              size="lg"
              className="[&>label>span]:font-medium"
              inputClassName="text-sm"
              {...register('password')}
              error={errors.password?.message}
            />
            <div className="flex items-center justify-between pb-2">
              <Checkbox {...register('rememberMe')} label="아이디 기억하기" variant="flat" className="[&>label>span]:font-medium" />
              {/* <Link
                href={routes.auth.forgotPassword1}
                className="h-auto p-0 text-sm font-semibold text-blue underline transition-colors hover:text-gray-900 hover:no-underline"
              >
                Forget Password?
              </Link> */}
            </div>
            <Button className="w-full" type="submit" size="lg">
              <span>로그인</span> <PiArrowRightBold className="ms-2 mt-0.5 h-6 w-6" />
            </Button>
          </div>
        )}
      </Form>
      {/* <Text className="mt-6 text-center leading-loose text-gray-500 lg:mt-8 lg:text-start">
        Don’t have an account?{' '}
        <Link
          href={routes.auth.signUp1}
          className="font-semibold text-gray-700 transition-colors hover:text-blue"
        >
          Sign Up
        </Link>
      </Text> */}
    </>
  );
}
